import React from 'react'
import PropTypes from 'prop-types'
import styled from 'react-emotion'
import yup from 'yup'
import { regularFontFamily, mediumMediaQuery } from 'utils/style-helpers'
import Form from 'components/Form'
import Field from 'components/Form/Field'
import Error from 'components/Form/Error'
import Button from 'components/Form/Button'
import { ButtonCss } from 'components/LinkButton'

const Container = styled.div`
  text-align: center;
  min-width: 700px;
  min-height: 450px;
`

const Note = styled.p`
  color: #616161;
  font-size: 18px;
  text-align: left;
`

const Required = styled.span`
  color: #4caf50;
  font-weight: bold;
`

const StyledForm = styled(Form)`
  font-size: 18px;
  margin: 30px 0 0 0;

  ${mediumMediaQuery} {
    max-width: 400px;
  }
`

const Group = styled.div`
  color: #2c2c2c;
  text-align: left;
  margin: 0 0 20px 0;

  &:last-child {
    margin-bottom: 0;
  }
`

const Label = styled.label`
  display: block;
  margin: 0 0 5px 0;

  ${Required} {
    margin-left: 2px;
  }
`

const StyledField = styled(Field)`
  ${regularFontFamily()}
  border: none;
  border-bottom: 1px solid #2c2c2c;
  display: block;
  padding: 10px;
  width: 100%;
`

const StyledError = styled(Error)`
  color: red;
  font-size: 14px;
  margin: 5px 0 0 0;
`

const Submit = styled(Button)`
  ${ButtonCss};
  font-size: 18px;
  margin: 40px 0 0 0;
  min-width: 260px;
`

const IFrame = styled.iframe`
  height: 100%;
  position: absolute;
  left: 0;
  top: 100px;
  border: 10px solid #459d6e;
  background: #459d6e;
`

const signUpFormNextUrl = () => {
  let { protocol, hostname, port } = window.location
  let portPart = (port == 80 || port == 443) ? null : `:${port}`

  return `${protocol}//${hostname}${portPart}/thanks`
}

const SignUpSchema = yup.object().shape({
  email: yup.string().required('Please enter your email.').email('Please enter a valid email.'),
  name: yup.string().required('Please enter your name.'),
  phone_number: yup.string().required('Please enter your phone number.'),
  group_restaurant_name: yup.string().required('Please enter your group/restaurant name.')
})

const SignUp = () => (
  <Container>
    <IFrame src="https://chouxbox.acuityscheduling.com/" width="100%" height="100%" frameborder="0"></IFrame>
  </Container>
)

export default SignUp



// WEBPACK FOOTER //
// ./src/components/SignUp/index.js